import React, {Component} from 'react';

import styles from './Error.less';

const {
	'error': error_class
} = styles;

export default class Error extends Component {
	render() {
		const {error, className} = this.props;

		if (!error) {
			return null;
		}

		const error_classes = [error_class];
		if (className) {
			error_classes.push(className);
		}

		return (
			<span className={error_classes.join(' ')}>{error}</span>
		);
	}
}